export default __webpack_public_path__ + "static/media/nbmon1.afd72481.png";